<!-- 菜单选择框 -->
<template>
  <vxe-modal
    v-model="formVisible"
    title="菜单选择框"
    width="60%"
    height="80%"
    @show="showWindow"
  >
    <div class="top-box">
      <div class="bts-box">
        <el-button type="primary" size="mini" @click="Sure">选中</el-button>
        <el-button type="primary" size="mini" @click="SureAndClose"
          >选中并关闭</el-button
        >
      </div>
    </div>
    <div class="mian-box" ref="scrollRef">
      <!-- 数据展示区域 -->
      <vxe-grid
        border
        resizable
        show-overflow
        highlight-hover-row
        :sort-config="{ trigger: 'cell' }"
        size="mini"
        :column-config="{ minWidth: '80px' }"
        :height="scrollerHeight"
        :mouse-config="{ area: true, extension: true }"
        ref="xTable"
        highlight-current-row
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true,
        }"
        :seq-config="{
          startIndex: (tablePage.currentPage - 1) * tablePage.pageSize,
        }"
        :pager-config="tablePage"
        :data="tableData"
        @page-change="handlePageChange"
        @checkbox-change="handleChangeCheck"
        :columns="gridColumns"
        @checkbox-all="handleChangeCheck"
      >
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script>
export default {
  props: {
    menuArgs: {
      type: String,
      default: ''
    },
    sqlTitle: {
      type: String,
      default: 'select'
    }
  },
  created() {
    this.InitColumn()
  },
  data() {
    return {
      // 是否显示
      formVisible: false,
      tableData: [],
      // 动态查找获取条件
      searchVuePath: 'BAuthorityList',
      // 动态查找条件
      searchObjects: [],
      // 查找条件是否全部返回
      fullSearchFilter: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 50,
        align: 'right',
        pageSizes: [50, 200],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 列头
      gridColumns: [],
      // 已选中数据
      selectRecords: []
    }
  },
  methods: {
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        { type: 'seq', width: '45', cellType: 'string' },
        { type: 'checkbox', width: '40', cellType: 'string' },
        { field: 'module', title: '模块名称', cellType: 'string' },
        { field: 'text', title: '菜单名称', width: '160', cellType: 'string' },
        { field: 'type', title: '菜单类型', cellType: 'string' }
      ]
    },
    showWindow() {
      this.searchObjects = []
      this.BindData()
    },
    // 确认返回
    Sure() {
      this.$emit('sureSelectBack', [...this.selectRecords])
    },
    SureAndClose() {
      this.Sure()
      this.formVisible = false
    },
    // 绑定数据
    BindData() {
      this.selectRecords = []
      this.searchObjects = []
      this.tablePage.currentPage = 1
      this.tablePage.pageSize = 50
      this.list()
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.list()
    },
    // 查找控件确认查找
    sureSearch(searchObjects) {
      this.selectRecords = []
      this.searchObjects = searchObjects
      this.tablePage.currentPage = 1
      this.list()
    },
    // 获取选择
    handleChangeCheck({ records }) {
      this.selectRecords = this.selectRecords.filter(item => {
        return item.pageIndex !== this.tablePage.currentPage
      })
      records.forEach(item => {
        let record = { ...item }
        record['pageIndex'] = this.tablePage.currentPage
        this.selectRecords.push(record)
      })
    },
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Common/BAuthorityList/select-authority', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        menuArgs: this.menuArgs,
        sqlTitle: this.sqlTitle,
        searchObjects: this.searchObjects
      })
      if (res.isSuccess) {
        this.tableData = res.data.rows
        this.tablePage.total = res.data.totals
      } else {
        this.$message.error(res.errorMessage)
        this.tableData = []
      }
      this.tableData.forEach(item => {
        const option = this.selectRecords.filter(i => {
          return item.id === i.id
        })
        if (option.length > 0) {
          this.$refs.xTable.setCheckboxRow(item, true)
        }
      })
    }
  },
  computed: {
    scrollerHeight() {
      if (this.formVisible) {
        return Number(this.$store.state.clientHeight) * 0.8 - 43 - 35 - 20
      } else {
        return '100px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.top-box {
  width: 100%;
  height: 35px;
}
.mian-box {
  height: calc(80vh - 200px);
  width: 100%;
}
.bts-box {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
